import React, { useState, useEffect } from 'react';
import { Activity, TrendingUp } from 'lucide-react';

const TotalApiVisitsCard = ({ className }) => {
  const [totalCalls, setTotalCalls] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch('/api/stats/counter');
        
        if (!response.ok) {
          throw new Error('Failed to fetch API stats');
        }
        
        const data = await response.json();
        if (data.success) {
          setTotalCalls(data.total_calls || 0);
        } else {
          throw new Error(data.message || 'Failed to load counter data');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching API stats:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    
    // Optional: Set up a refresh interval
    const intervalId = setInterval(fetchData, 300000); // Refresh every 5 minutes
    
    return () => clearInterval(intervalId);
  }, []);

  // Format number with commas
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className={`bg-white rounded-md shadow-sm overflow-hidden ${className}`}>
      <div className="px-4 py-5 sm:p-6 flex items-center space-x-4">
        <div className="flex-shrink-0 bg-blue-100 rounded-md p-3">
          <TrendingUp className="h-6 w-6 text-blue-600" />
        </div>
        <div>
          {isLoading ? (
            <div className="h-8 w-28 bg-gray-200 rounded animate-pulse"></div>
          ) : error ? (
            <div className="text-red-500 text-sm">Error loading data</div>
          ) : (
            <>
              <div className="text-xl font-semibold text-gray-900">
                {formatNumber(totalCalls)}
              </div>
              <div className="text-sm text-gray-500">
                Total API Usage counter
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TotalApiVisitsCard;